function initStickyHeader() {
  var trustBar = document.querySelector('.nhs-trust-bar-section');
  var header = document.querySelector('.section-header');
  
  if (trustBar && header && !trustBar.parentElement.style.position) {
    var wrapper = document.createElement('div');
    wrapper.style.cssText = 'position:sticky;top:0;z-index:100;width:100%;';
    trustBar.parentNode.insertBefore(wrapper, trustBar);
    wrapper.appendChild(trustBar);
    wrapper.appendChild(header);

    if (document.body.classList.contains('template-product')) {
      var addToCartBtn = document.querySelector('.product-form__submit');
      if (addToCartBtn) {
        function checkScroll() {
          var rect = addToCartBtn.getBoundingClientRect();
         if (rect.bottom < 100) {
  wrapper.style.visibility = 'hidden';
  wrapper.style.height = '0';
  wrapper.style.overflow = 'hidden';
} else {
  wrapper.style.visibility = '';
  wrapper.style.height = '';
  wrapper.style.overflow = '';
}
        }
        window.addEventListener('scroll', checkScroll, {passive: true, capture: true});
        checkScroll();
      }
    }
  }
}

if (document.readyState === 'complete') {
  setTimeout(initStickyHeader, 300);
} else {
  window.addEventListener('load', function() {
    setTimeout(initStickyHeader, 300);
  });
}